export enum roleType {
  ADMIN = 'admin',
  SBJ_ADMIN = 'sbj_admin',
  SBJ_SHOP = 'sbj_shop',
  NONE = 'none',
}

export const ALLOWED_ACCESS_FOR_ALL: roleType[] = [
  roleType.ADMIN,
  roleType.SBJ_ADMIN,
  roleType.SBJ_SHOP,
]

export const ALLOWED_ACCESS_ONLY_FOR_ADMIN: roleType[] = [roleType.ADMIN]

export const ALLOWED_ACCESS_ROOT_ONLY: roleType[] = [roleType.ADMIN]

export const ALLOWED_ACCESS_FOR_SBJ_ADMIN: roleType[] = [
  roleType.ADMIN,
  roleType.SBJ_ADMIN,
]

export const ALLOWED_ACCESS_FOR_SBJ_ROLES: roleType[] = [
  roleType.ADMIN,
  roleType.SBJ_ADMIN,
  roleType.SBJ_SHOP,
]

// 権限定義
export enum Permission {
  // 管理者権限
  ADMIN_ALL = 'admin:all',

  // 売上データ権限
  ROOTC_SALES_DATA_READ = 'sales_data:read',
  SBJ_SALES_DATA_READ = 'sbj_sales_data:read',
  SALES_DATA_EXPORT = 'sales_data:export',

  // ステーション管理権限
  STATION_READ = 'station:read',
  STATION_CREATE = 'station:create',
  STATION_UPDATE = 'station:update',
  STATION_DELETE = 'station:delete',
  STATION_POWER = 'station:power',
  STATION_PRODUCT_AVAILABILITY_UPDATE = 'station_product_availability:update',

  // マシン管理権限
  MACHINE_READ = 'machine:read',
  MACHINE_CREATE = 'machine:create',
  MACHINE_UPDATE = 'machine:update',
  MACHINE_DELETE = 'machine:delete',
  MACHINE_CONTROL = 'machine:control',
  MACHINE_VERSION = 'machine:version',

  // KIOSK管理権限
  KIOSK_READ = 'kiosk:read',
  KIOSK_CREATE = 'kiosk:create',
  KIOSK_UPDATE = 'kiosk:update',
  KIOSK_DELETE = 'kiosk:delete',

  // SIM管理権限
  SIM_READ = 'sim:read',
  SIM_CREATE = 'sim:create',
  SIM_UPDATE = 'sim:update',
  SIM_DELETE = 'sim:delete',

  // SDカード管理権限
  SD_CARD_READ = 'sd_card:read',
  SD_CARD_CREATE = 'sd_card:create',
  SD_CARD_UPDATE = 'sd_card:update',
  SD_CARD_DELETE = 'sd_card:delete',

  // マシン紐付け権限
  MACHINE_LINK_READ = 'machine_link:read',
  MACHINE_LINK_CREATE = 'machine_link:create',
  MACHINE_LINK_UPDATE = 'machine_link:update',
  MACHINE_LINK_DELETE = 'machine_link:delete',

  // KIOSK紐付け権限
  KIOSK_LINK_READ = 'kiosk_link:read',
  KIOSK_LINK_CREATE = 'kiosk_link:create',
  KIOSK_LINK_UPDATE = 'kiosk_link:update',
  KIOSK_LINK_DELETE = 'kiosk_link:delete',

  // リアルタイム配信権限
  REALTIME_READ = 'realtime:read',
  REALTIME_CREATE = 'realtime:create',
  REALTIME_UPDATE = 'realtime:update',
  REALTIME_DELETE = 'realtime:delete',

  // サイネージバナー権限
  SIGNAGE_BANNER_READ = 'signage_banner:read',
  SIGNAGE_BANNER_CREATE = 'signage_banner:create',
  SIGNAGE_BANNER_UPDATE = 'signage_banner:update',
  SIGNAGE_BANNER_DELETE = 'signage_banner:delete',

  // オーダー管理権限
  ORDER_READ = 'order:read',
  ORDER_CREATE = 'order:create',
  ORDER_UPDATE = 'order:update',
  ORDER_DELETE = 'order:delete',

  // ユーザー管理権限
  USER_READ = 'user:read',
  USER_CREATE = 'user:create',
  USER_UPDATE = 'user:update',
  USER_DELETE = 'user:delete',

  // 管理ユーザー権限
  ADMIN_USER_READ = 'admin_user:read',
  ADMIN_USER_UPDATE = 'admin_user:update',

  // ポイント管理権限
  POINT_READ = 'point:read',
  POINT_CREATE = 'point:create',
  POINT_UPDATE = 'point:update',
  POINT_DELETE = 'point:delete',

  // 手動発行クーポン権限
  MANUAL_COUPON_READ = 'manual_coupon:read',
  MANUAL_COUPON_CREATE = 'manual_coupon:create',
  MANUAL_COUPON_UPDATE = 'manual_coupon:update',
  MANUAL_COUPON_DELETE = 'manual_coupon:delete',

  // 自動発行クーポン権限
  AUTO_COUPON_READ = 'auto_coupon:read',
  AUTO_COUPON_CREATE = 'auto_coupon:create',
  AUTO_COUPON_UPDATE = 'auto_coupon:update',
  AUTO_COUPON_DELETE = 'auto_coupon:delete',

  // アイテム管理権限
  ITEM_READ = 'item:read',
  ITEM_CREATE = 'item:create',
  ITEM_UPDATE = 'item:update',
  ITEM_DELETE = 'item:delete',

  // アイテムランキング権限
  ITEM_RANKING_READ = 'item_ranking:read',
  ITEM_RANKING_CREATE = 'item_ranking:create',
  ITEM_RANKING_UPDATE = 'item_ranking:update',
  ITEM_RANKING_DELETE = 'item_ranking:delete',

  // KIOSK価格管理権限
  KIOSK_PRICE_READ = 'kiosk_price:read',
  KIOSK_PRICE_CREATE = 'kiosk_price:create',
  KIOSK_PRICE_UPDATE = 'kiosk_price:update',
  KIOSK_PRICE_DELETE = 'kiosk_price:delete',

  // フード管理権限
  FOOD_READ = 'food:read',
  FOOD_CREATE = 'food:create',
  FOOD_UPDATE = 'food:update',
  FOOD_DELETE = 'food:delete',

  // ポイント交換グッズ権限
  POINT_EXCHANGE_GOODS_READ = 'point_exchange_goods:read',
  POINT_EXCHANGE_GOODS_CREATE = 'point_exchange_goods:create',
  POINT_EXCHANGE_GOODS_UPDATE = 'point_exchange_goods:update',
  POINT_EXCHANGE_GOODS_DELETE = 'point_exchange_goods:delete',

  // グッズ発送管理権限
  GOODS_SHIPPING_READ = 'goods_shipping:read',
  GOODS_SHIPPING_CREATE = 'goods_shipping:create',
  GOODS_SHIPPING_UPDATE = 'goods_shipping:update',
  GOODS_SHIPPING_DELETE = 'goods_shipping:delete',

  // グッズ受注管理権限
  GOODS_ORDER_READ = 'goods_order:read',
  GOODS_ORDER_CREATE = 'goods_order:create',
  GOODS_ORDER_UPDATE = 'goods_order:update',
  GOODS_ORDER_DELETE = 'goods_order:delete',

  // アプリバナー権限
  APP_BANNER_READ = 'app_banner:read',
  APP_BANNER_CREATE = 'app_banner:create',
  APP_BANNER_UPDATE = 'app_banner:update',
  APP_BANNER_DELETE = 'app_banner:delete',

  // アプリお知らせ権限
  APP_NOTIFICATION_READ = 'app_notification:read',
  APP_NOTIFICATION_CREATE = 'app_notification:create',
  APP_NOTIFICATION_UPDATE = 'app_notification:update',
  APP_NOTIFICATION_DELETE = 'app_notification:delete',

  // エマージェンシー履歴権限
  EMERGENCY_HISTORY_READ = 'emergency_history:read',
  EMERGENCY_HISTORY_CREATE = 'emergency_history:create',
  EMERGENCY_HISTORY_UPDATE = 'emergency_history:update',
  EMERGENCY_HISTORY_DELETE = 'emergency_history:delete',

  // マシン通知履歴権限
  MACHINE_ERROR_HISTORY_READ = 'machine_error_history:read',
  MACHINE_ERROR_HISTORY_CREATE = 'machine_error_history:create',
  MACHINE_ERROR_HISTORY_UPDATE = 'machine_error_history:update',
  MACHINE_ERROR_HISTORY_DELETE = 'machine_error_history:delete',

  // サブスクリプション履歴権限
  SUBSCRIPTION_HISTORY_READ = 'subscription_history:read',
  SUBSCRIPTION_HISTORY_CREATE = 'subscription_history:create',
  SUBSCRIPTION_HISTORY_UPDATE = 'subscription_history:update',
  SUBSCRIPTION_HISTORY_DELETE = 'subscription_history:delete',

  // VNC接続権限
  VNC_CONNECT = 'vnc:connect',

  // キャンペーン管理権限
  CAMPAIGN_READ = 'campaign:read',
  CAMPAIGN_CREATE = 'campaign:create',
  CAMPAIGN_UPDATE = 'campaign:update',
  CAMPAIGN_DELETE = 'campaign:delete',

  // カメラストリーミングビューアー権限
  CAMERA_STREAMING_VIEWER_READ = 'camera_streaming_viewer:read',

  // レポート権限
  REPORT_READ = 'report:read',
  REPORT_EXPORT = 'report:export',

  // システム設定権限
  SYSTEM_READ = 'system:read',
  SYSTEM_UPDATE = 'system:update',
}

const uniquePermissions = (permissions: Permission[]): Permission[] => {
  return Array.from(new Set(permissions))
}

const basicOperationalPermissions: Permission[] = [
  Permission.ORDER_READ,
  Permission.ORDER_UPDATE,
  Permission.EMERGENCY_HISTORY_READ,
  Permission.SBJ_SALES_DATA_READ,
]

const deviceManagementPermissions: Permission[] = [
  Permission.STATION_READ,
  Permission.STATION_CREATE,
  Permission.STATION_UPDATE,
  Permission.STATION_DELETE,
  Permission.STATION_POWER,
  Permission.STATION_PRODUCT_AVAILABILITY_UPDATE,
  Permission.MACHINE_READ,
  Permission.MACHINE_CREATE,
  Permission.MACHINE_UPDATE,
  Permission.MACHINE_DELETE,
  Permission.MACHINE_CONTROL,
  Permission.MACHINE_VERSION,
  Permission.KIOSK_READ,
  Permission.KIOSK_CREATE,
  Permission.KIOSK_UPDATE,
  Permission.KIOSK_DELETE,
  Permission.SIM_READ,
  Permission.SIM_CREATE,
  Permission.SIM_UPDATE,
  Permission.SIM_DELETE,
  Permission.SD_CARD_READ,
  Permission.SD_CARD_CREATE,
  Permission.SD_CARD_UPDATE,
  Permission.SD_CARD_DELETE,
  Permission.MACHINE_LINK_READ,
  Permission.MACHINE_LINK_CREATE,
  Permission.MACHINE_LINK_UPDATE,
  Permission.MACHINE_LINK_DELETE,
  Permission.KIOSK_LINK_READ,
  Permission.KIOSK_LINK_CREATE,
  Permission.KIOSK_LINK_UPDATE,
  Permission.KIOSK_LINK_DELETE,
  Permission.REALTIME_READ,
  Permission.REALTIME_CREATE,
  Permission.REALTIME_UPDATE,
  Permission.REALTIME_DELETE,
  Permission.MACHINE_ERROR_HISTORY_READ,
  Permission.VNC_CONNECT,
]

const masterManagementPermissions: Permission[] = [
  Permission.ITEM_READ,
  Permission.ITEM_CREATE,
  Permission.ITEM_UPDATE,
  Permission.ITEM_DELETE,
  Permission.FOOD_READ,
  Permission.FOOD_CREATE,
  Permission.FOOD_UPDATE,
  Permission.FOOD_DELETE,
  Permission.KIOSK_PRICE_READ,
  Permission.KIOSK_PRICE_CREATE,
  Permission.KIOSK_PRICE_UPDATE,
  Permission.KIOSK_PRICE_DELETE,
  Permission.ITEM_RANKING_READ,
  Permission.ITEM_RANKING_CREATE,
  Permission.ITEM_RANKING_UPDATE,
  Permission.ITEM_RANKING_DELETE,
]

const masterReadOnlyPermissions: Permission[] = [
  Permission.ITEM_READ,
  Permission.FOOD_READ,
]

const signageManagementPermissions: Permission[] = [
  Permission.SIGNAGE_BANNER_READ,
  Permission.SIGNAGE_BANNER_CREATE,
  Permission.SIGNAGE_BANNER_UPDATE,
  Permission.SIGNAGE_BANNER_DELETE,
]

const adminUserManagementPermissions: Permission[] = [
  Permission.ADMIN_USER_READ,
  Permission.ADMIN_USER_UPDATE,
]

const userManagementPermissions: Permission[] = [
  Permission.USER_READ,
  Permission.USER_CREATE,
  Permission.USER_UPDATE,
  Permission.USER_DELETE,
]

const buildPermissions = (...groups: Permission[][]): Permission[] =>
  uniquePermissions(groups.flat())

const sbjShopPermissions = buildPermissions(
  basicOperationalPermissions,
  deviceManagementPermissions,
  masterReadOnlyPermissions,
).filter(permission => permission !== Permission.STATION_PRODUCT_AVAILABILITY_UPDATE)

const sbjAdminPermissions = buildPermissions(
  sbjShopPermissions,
  masterManagementPermissions,
  signageManagementPermissions,
  adminUserManagementPermissions,
  userManagementPermissions,
  [Permission.STATION_PRODUCT_AVAILABILITY_UPDATE],
  // TODO: 売上データの取り扱い方針が固まったら Permission.SALES_DATA_EXPORT を復帰させる
)

// ロールに応じた権限マッピング
export const ROLE_PERMISSIONS: Record<roleType, Permission[]> = {
  [roleType.ADMIN]: Object.values(Permission),
  [roleType.SBJ_ADMIN]: sbjAdminPermissions,
  [roleType.SBJ_SHOP]: sbjShopPermissions,
  [roleType.NONE]: [],
}

// 権限チェック関数
export const hasPermission = (userRole: roleType, permission: Permission): boolean => {
  const permissions = ROLE_PERMISSIONS[userRole] || []
  return permissions.includes(permission)
}

export const hasAnyPermission = (userRole: roleType, permissions: Permission[]): boolean => {
  return permissions.some(permission => hasPermission(userRole, permission))
}

export const hasAllPermissions = (userRole: roleType, permissions: Permission[]): boolean => {
  return permissions.every(permission => hasPermission(userRole, permission))
}

// ロールチェック関数
export const isAdmin = (role: roleType): boolean => {
  return role === roleType.ADMIN || role === roleType.SBJ_ADMIN
}

export const isSbjUser = (role: roleType): boolean => {
  return [roleType.SBJ_ADMIN, roleType.SBJ_SHOP].includes(role)
}
